import React from 'react';
import PureOfferCard from '../../molecules/PureOfferCard';
import PropTypes from 'prop-types';
import { ComparisonContext } from '../../../contexts/comparison';


export const TrimCardFavorite = ({ slug, ...props }) => {
  const { addTrimLevel, removeTrimLevel, compareConfig } = React.useContext(ComparisonContext);
  return <PureOfferCard
    {...props}
    slug={slug}
    onToggleFavorite={() => compareConfig?.trimLevels?.indexOf(slug) === -1 ? addTrimLevel(slug) : removeTrimLevel(slug)}
    favorite={compareConfig?.trimLevels?.indexOf(slug) !== -1}
  />;
};

TrimCardFavorite.propTypes={
  slug:PropTypes.string.isRequired,
};


export default TrimCardFavorite;